import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "",
  name: "New Territory",
  description: "",
  codes: [],
  edit: false,
  unknown: [],
  // Nullable: no rep is assigned by default. Persisted through
  // `CreateTerritory` / `UpdateTerritory` as the `repId` variable.
  repId: null,
};

const mergeCodes = (current = [], newCodes = []) => {
  if (!newCodes || newCodes.length === 0) {
    return current;
  } else {
  }
};

export const territorySlice = createSlice({
  name: "territory",
  initialState,
  reducers: {
    setTerritory: (state, { payload }) => {
      state = {
        ...state,
        ...payload,
        edit: true,
      };
      return state;
    },
    setId: (state, value) => {
      state.id = value.payload;
    },
    setName: (state, value) => {
      state.name = value.payload;
    },
    toggleCode: (state, { payload }) => {
      const { codes } = state;
      const idx = codes.indexOf(payload);
      if (idx !== -1) {
        codes.splice(idx, 1);
      } else {
        const toCheck = [...codes];
        if (payload.includes("POSTCODE_AREA")) {
          // Remove children
          const [, id] = payload.split("/");
          // Hard-coded is bad!
          const test = `POSTCODE_DISTRICT/${id}\\d+D*`;
          const ev = new RegExp(test, "i");
          toCheck.forEach((c, i) => {
            if (ev.test(c)) {
              const idx = codes.indexOf(c);
              codes.splice(idx, 1);
            }
          });
        }
        codes.push(payload);
      }
      state.unknown = [];
    },
    addCodes: (state, { payload }) => {
      const { codes } = state;
      let add = [];
      if (Array.isArray(payload)) {
        add = payload;
      } else {
        add = [payload];
      }

      codes.forEach((code) => {});

      const nCodes = Array.from(new Set([...codes, ...add]));

      state.codes = nCodes;
      state.unknown = [];
    },
    replaceCodes: (state, { payload }) => {
      state.codes = payload;
      state.unknown = [];
    },
    startEdit: (state) => {
      state.edit = true;
    },
    stopEdit: (state) => {
      state.edit = false;
    },
    removeCode: (state, value) => {
      const { codes } = state;
      if (codes.indexOf(value.payload) !== -1) {
        codes.splice(codes.indexOf(value.payload), 1);
        state.codes = [...codes];
      }
      state.unknown = (state.unknown ?? []).filter((c) => c !== value.payload);
    },
    setDescription: (state, { payload }) => {
      state.description = payload;
    },
    setRepId: (state, { payload }) => {
      // Accepts a string rep code or null. Undefined is coerced to
      // null so the form always sends an explicit "no rep" signal.
      state.repId = payload ?? null;
    },
    clearCodes: (state) => {
      state.codes = [];
      state.unknown = [];
    },
    setUnknownCodes: (state, { payload }) => {
      state.unknown = Array.isArray(payload) ? [...payload] : [];
    },
    clearUnknownCodes: (state) => {
      state.unknown = [];
    },
    clearTerritory: (state, val) => {
      return { ...initialState, edit: false };
    },
  },
});

export const {
  setName,
  setDescription,
  setRepId,
  addCodes,
  toggleCode,
  removeCode,
  clearCodes,
  setId,
  setTerritory,
  clearTerritory,
  startEdit,
  stopEdit,
  replaceCodes,
  setUnknownCodes,
  clearUnknownCodes,
} = territorySlice.actions;

const isEditing = ({ territoryReducer }) => territoryReducer.isEditing;
const selectedAreaIds = ({ territoryReducer }) => territoryReducer.selectedAreaIds;

export const editStatus = createSelector(
  [isEditing, selectedAreaIds],
  (isEditing, selectedAreaIds) => {
    return {
      isEditing,
      selectedAreaIds,
    };
  },
);

export default territorySlice.reducer;
